import React from 'react';
import { FormattedMessage} from 'react-intl';
import { get, range } from 'lodash';
import { formatNumber } from '@dmm/lib-common/lib/formatting';
import messages from './translationMessages';
import { formatMessage as t } from './language';
import { getLocale } from './uomHelper';

export const getNumberOfPages = (numberOfListings, params) => {
  const pageSize = parseInt(get(params, 'pageSize', '28'));
  return parseInt(numberOfListings / pageSize) + 1;
};

export const getResultsCount = (params, totalItems, locale) => {
  let { page, pageSize } = params;
  let from = (page - 1) * pageSize + 1;
  let to = Math.min(totalItems, pageSize * page);
  locale = getLocale();
  return totalItems ?
    <FormattedMessage {...messages.searchHeader.viewing.listings} values={{from: formatNumber(from, locale),
      to: formatNumber(to, locale), total: formatNumber(totalItems, locale)}} /> :
    t(messages.searchHeader.viewing.noListings);
};

export const getPaginationData = (params, totalItems, maxPages, visiblePages) => {
  let { page, pageSize } = params;
  page = +(page);
  pageSize = +(pageSize);
  const searchMaxBoats = pageSize * maxPages;
  totalItems = Math.min(searchMaxBoats, totalItems);
  let pages = Math.ceil(totalItems / pageSize) < maxPages ? Math.ceil(totalItems / pageSize) : maxPages;
  let toPage;
  let fromPage;
  let delta;

  if (visiblePages >= pages) {
    fromPage = 1;
    toPage = pages;
  } else {
    delta = Math.floor(visiblePages / 2);
    if (page - delta < 1) {
      fromPage = 1;
      toPage = visiblePages;
    } else {
      if (page + delta >= pages) {
        toPage = pages;
        fromPage = pages - visiblePages + 1;
      } else {
        toPage = page + delta;
        fromPage = page - delta;
      }
    }
  }

  let response = {
    page: page,
    pageSize: pageSize,
    isFirstPage: page === 1,
    isLastPage: page === pages || totalItems <= 28,
    visibleNumbers: range(fromPage, toPage + 1)
  };

  return response;
};

export const setPosition = (pos, i) => {
  return { position: (pos.page - 1) * pos.pageSize + i, page: pos.page};
};
